import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo8/candidato.png";
import Imagen2 from "../../../images/modulo8/candidata.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo8 } from "../../../routes/Module8";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import Card from "../../../components/Card";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 4.mp3";

const Actividad4 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "option1" },
    ans2: { value: "", valid: "", correctValue: "option2" },
  });
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[3];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo8.content[0].activities[4].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[4].path}`,
    titlePrev: `${modulo8.content[0].activities[2].name}`,
    linkPrev: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[2].path}`,
  };

  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"] === answers[key]["value"]
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...answers, newAnswers });
  };
  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo8.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>
          Estas personas son candidatos a una elección y en la mesa se ven los
          votos que obtuvieron. ¿Quién tuvo más votos: el candidato o la
          candidata? Marca la opción correcta.
        </li>
      </ul>

      <div className="row">
        <div className="col-md-6">
          <Card>
            <input
              className={"form-check-input me-1 " + answers.ans1.valid}
              type="radio"
              name="ans1"
              value="option1"
              checked={answers.ans1.value === "option1"}
              onChange={() => console.log("ans1")}
              onClick={() =>
                setAnswers({
                  ...answers,
                  ans1: { ...answers["ans1"], value: "option1" },
                })
              }
            />
            <img src={Imagen1} alt="Candidato" className="img-fluid mb-1" />
          </Card>
        </div>
        <div className="col-md-6 ">
          <Card>
            <input
              className={"form-check-input me-1  " + answers.ans2.valid}
              type="radio"
              name="ans2"
              value="option2"
              checked={answers.ans1.value === "option2"}
              onChange={() => console.log("ans2")}
              onClick={() =>
                setAnswers({
                  ...answers,
                  ans1: { ...answers["ans2"], value: "option2" },
                })
              }
            />
            <img src={Imagen2} alt="Candidata" className="img-fluid mb-1" />
          </Card>
        </div>
      </div>

      <div className="d-flex w-100 justify-content-end my-4">
        <button
          className={`btn btn-${modulo8.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen la imagen y ayude a responder: la
          candidata mujer ganó porque tiene más votos (ganan los que consiguen
          más votos).
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
